<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 17 15"
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
  >
		<path :fill="fill" d="M16,5.8588273 C16.5128358,5.8588273 16.9355072,6.24486749 16.9932723,6.74220618 L17,6.8588273 L17,13 C17,14.0543618 16.1841222,14.9181651 15.1492623,14.9945143 L15,15 L2,15 C0.945638205,15 0.0818348781,14.1841222 0.00548573643,13.1492623 L0,13 L0,6.8588273 C0,6.30654255 0.44771525,5.8588273 1,5.8588273 C1.51283584,5.8588273 1.93550716,6.24486749 1.99327227,6.74220618 L2,6.8588273 L2,13 L15,13 L15,6.8588273 C15,6.30654255 15.4477153,5.8588273 16,5.8588273 Z M15,0 C16.1045695,0 17,0.8954305 17,2 C17,2.05868634 16.9949447,2.11619195 16.9852457,2.1721051 L16.967266,2.25472902 C16.9316842,2.49155574 16.812101,2.71526981 16.6180958,2.87679479 L16.5241407,2.94620794 L9.04690548,7.83078567 C8.74942741,8.02511615 8.37448197,8.04537612 8.06099274,7.89210694 L7.94658637,7.82649788 L0.595128613,2.94192015 C0.556333298,2.91614312 0.51991983,2.88812532 0.485945742,2.85815211 C0.19490293,2.68326611 0,2.36439406 0,2 C0,0.945638205 0.815877791,0.0818348781 1.85073766,0.00548573643 L2,0 L15,0 Z M14.316,1.999 L2.789,1.999 L8.505,5.796 L14.316,1.999 Z"></path>
  </svg>
</template>

<script>
export default {
  props: {
		type: {
			type: String,
			ddefault: ''
		},
    width: {
      type: Number,
      default: 17,
    },
    height: {
      type: Number,
      default: 15,
    },
    fill: {
      type: String,
      default: "#000",
    },
  },
};
</script>

<style scoped>
path {
	transition: all .3s;
}
</style>
